import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import Rapid7InsightCloudMappingForm from "./Rapid7InsightCloudMappingForm";

const Rapid7InsightCloudCredentialsForm = forwardRef((props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "apiKey",
      label: "Api Key",
      required: true,
      type: FieldTypes.PASSWORD,
    },
  ];
  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      //@ts-expect-error
      fields={fields}
      MappingForm={Rapid7InsightCloudMappingForm}
    />
  );
});

export default Rapid7InsightCloudCredentialsForm;
